module.exports = __webpack_public_path__ + "static/media/close-alt.c2b6a44c.png";